export default "__VITE_ASSET__ca245912__"